import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PerplexityMessage, PerplexityResponse } from 'model/modules/chatAi/chatAi';

export const perplexityApi = createApi({
  reducerPath: 'perplexityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.perplexity.ai',
    prepareHeaders: (headers) => {
      headers.set('Authorization', 'Bearer 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');
      headers.set('Content-Type', 'application/json');

      return headers;
    },
  }),
  endpoints: (builder) => ({
    sendPerplexityMessage: builder.mutation<string, PerplexityMessage[]>({
      query: (messages) => ({
        url: '/chat/completions',
        method: 'POST',
        body: {
          model: 'sonar-pro',
          messages,
        },
      }),
      transformResponse: (response: PerplexityResponse): string => {
        return response.choices?.[0]?.message?.content ?? '';
      },
    }),
  }),
});

export const { useSendPerplexityMessageMutation } = perplexityApi;
